/** @format */

import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import { getblogbyid } from "../../../services/blog";
import { decryptString } from "../../../utils/common/hashData";
import { useLocation, useParams } from "react-router-dom";
const BlogDetail = () => {
  const location = useLocation();
  const id = location.state?.id || null;
  const { id: idParam } = useParams();
  const [datadetail, setDatadetail] = useState({
    creator_avatar: "",
    creator: "",
    title: "",
    content: "",
    thumbnail: "",
    category: "",
  });

  const getblogbyID = async () => {
    await getblogbyid(
      id
        ? decryptString({
            encryptedStr: id,
            secretKey: process.env.PRIVATE_KEY,
          })
        : decryptString({
            encryptedStr: idParam,
            secretKey: process.env.PRIVATE_KEY,
          })
    )
      .then((res) => {
        setDatadetail(res.data.data);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };
  useEffect(() => {
    getblogbyID();
  }, []);
  return (
    <div>
      <div className="max-w-[1140px] qhd:max-w-[60%]   mx-auto  flex flex-col  items-center gap-2 justify-center py-4">
        <div className="">
          <p className="text-primary text-center font-bold ">
            {datadetail?.category}
          </p>
        </div>
        <div className="text-justify max-w-[1140px] mx-auto ">
          <p className="text-primary text-[24px] text-center">
            {datadetail?.title}
          </p>
        </div>
        <div className="w-[20px] bg-primary h-[2px]"></div>
        <div className="flex gap-4 justify-center items-center">
          <p className="text-primary text-sm">
            Created by : {datadetail?.creator}
          </p>
        </div>
      </div>

      {/* image part */}
      <div className="max-w-[1140px] qhd:max-w-[60%] mx-auto ">
        <div className="pt-[70px]  gap-4 md:max-lg:w-[90%]">
          <div className=" pb-[100px]">
            <img
              className="w-full  object-cover md:rounded-xl pv:max-sm:object-fill  pv:max-sm:h-full "
              src={datadetail?.thumbnail}
              alt=""
            ></img>
          </div>
        </div>
        <div className=" w-[80%]  mx-auto text-[1.125rem] text-primary  whitespace-pre-line text-justify">
          <div className="ProseMirror">{parse(datadetail?.content)}</div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
